<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-24 09:49:07
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-26 17:22:26
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\components\CompleteRadioAll\ChartForRice.vue
 * @Description:  承保理赔一张图-统计承保统计图- 最新 政策保险完成比例左侧——水稻政策性保险
-->
<template>
  <div class="item">
    <div class="chart"
         ref="completeRadioAllChart">
    </div>

    <div class="info">{{label}}</div>
  </div>

</template>
<script>
import imgSrc from '../../../images/chartCenter.png'
export default {
  props: {
    // 标签 玉米大豆水稻……
    label: {
      type: String,

      default: '政策性保险'

    },
    // 图表数据
    chartData: {

      type: Object,
      default: () => ({
        dataList: [
          // {
          //   value: 39.86,
          //   name: '物化成本'
          // }, {
          //   value: 17.65,
          //   name: '完全成本'
          // }, {
          //   value: 41.76,
          //   name: '收入险'
          // }, {
          //   value: 58.82,
          //   name: '价格险'
          // }

        ],
        percent: 0
      })
    }

  },
  data () {
    return {
      imgSrc,
      chart: null,
      // color: ['#F8AF30', '#27F3FA', '#4392FD', '#2749F5'],
      color: ['#faf447', '#27f57a', '#4392FD', '#2749F5'],
      colorDefault: 'rgba(255,255,255,0.1)',
      percentDefaultShow: false // 是否显示默认数据

    }
  },
  mounted () {
    this.chart = this.$echarts.init(this.$refs.completeRadioAllChart)
    window.addEventListener('resize', () => {
      this.chart.resize()

      // console.log('图表reseize1')
    })
    this.initData()
  },
  computed: {

  },
  methods: {
    initData () {
      this.initChart()
    },
    initChart () {
      let option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          className: 'custom_tooltip_box',
          // formatter: '{b}<br />面积占比：{d}%',
          position: function (point) {
            return [point[0] + 10, point[1] - 80]
          },
          formatter: (params) => {
            if (params.name) {
              return `<div class='custom_tooltip_style'>
            <div class='custom_tooltip_inner'>${params.name}：${params.value}万亩<br />占比：${params.percent}%</div>

            </div>`
            }

            // return '{b}<br />面积占比：{d}%'
          },
          padding: [4, 20, 5, 10],
          textStyle: {
            color: '#91b9f6'
          },
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        graphic: { // 这个属性可以在饼图内部填充图片,文字等
          elements: [{
            type: 'image', // 需要填充图片,配置image,如果不需要图片可以配置其他的, text, circle, sector, ring, polygon, polyline, rect, line, bezierCurve, arc, group,
            style: {
              image: this.imgSrc, // 这里添加图片地址
              width: this.chart.getWidth() * 0.6,
              height: this.chart.getWidth() * 0.6
            },
            // center: ['40%', '50%']
            left: 'center', //
            top: 'center' // 配置图片居中
          }]
        },

        series: [
          // 背景环形
          {
            type: 'pie',
            radius: ['70%', '88%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            startAngle: -90,
            label: {
              show: this.percentDefaultShow, // false不显示饼图上的标签
              position: 'center', // inside（在饼图上显示）,outside(默认就会出现引导线) center
              formatter: `0%`,
              fontSize: 20,
              color: 'rgba(39, 204, 246, 1)',
              fontFamily: 'numFont'

            },
            zlevel: 1,
            labelLine: {
              normal: {
                show: false
              }
            },
            showEmptyCircle: true,

            itemStyle: {
              normal: {

                color: 'rgba(255,255,255,0.1)'
              }
            },
            data: [{ value: 100 }]
          },
          // 环形
          {
            type: 'pie',
            radius: ['70%', '88%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            startAngle: -90,
            label: {
              show: true, // false不显示饼图上的标签
              position: 'center', // inside（在饼图上显示）,outside(默认就会出现引导线) center
              formatter: `${this.chartData.percent}%`,
              fontSize: 18,
              lineHeight: 20,
              // fontWeight: 'bold',
              color: '#27CCF6',
              fontFamily: 'numFont'
            },
            zlevel: 1,
            labelLine: {
              normal: {
                show: false
              }
            },
            showEmptyCircle: true,
            color: ((this.chartData && this.chartData.percent) ? this.color : this.colorDefault),

            data: this.chartData.dataList
            // data: this.chartData1
          },
          // 环形分割线
          {
            type: 'gauge',
            radius: '89%',
            clockwise: true,
            startAngle: '90',
            center: ['50%', '50%'],
            endAngle: '-269.9999',
            splitNumber: 14,
            zlevel: 2,
            detail: {
              offsetCenter: [10, 20],
              formatter: ' '
            },
            axisLine: {
              lineStyle: {
                width: 0,
                opacity: 0
              }
            },
            axisTick: {
              show: false
            },
            markArea: {
              itemStyle: {
                color: '#0f0'
              }
            },
            splitLine: {
              show: true,
              length: '30%',
              distance: 0,
              padding: [0, 0, 0],
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.7)',
                width: 4
              }
            },
            axisLabel: {
              show: false
            }
          },

          // 外边框
          {
            name: '',
            type: 'pie',
            clockWise: true, // 顺时加载
            hoverAnimation: false, // 鼠标移入变大
            radius: ['99%', '100%'],
            center: ['50%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: 9,
                name: '',
                itemStyle: {
                  normal: {
                    borderWidth: 1,
                    borderColor: '#283138'
                  }
                }
              }]
          }

        ]
      }
      this.chart.setOption(option, true)
    }

  },
  watch: {
    chartData: {
      handler (val) {
        if (val) {
          this.initData()
        }
      },
      deep: true

    }
  }

}
</script>
<style lang="less" scoped>
.item {
  width: 100%;
  height: 85%;
  // flex: 1;
  display: flex;
  // // height: 70%;
  // min-width: 110px;
  // height: 145px;
  flex-direction: column;
  align-items: center;
  padding:0.5rem;
  box-sizing: border-box;
  // // justify-items: center;
  // box-sizing: border-box;
  // text-align: center;
  // padding: 0 5px 0;
  .chart {
    width: 90%;
    height: 100%;

    position: relative;
    top: -20px;
  }
  .info {
    color: #c4e0fa;
    font-size: 0.8rem;
    // font-weight: bold;
    font-family: numFont;
    letter-spacing: 1px;
    position: relative;
     top: -0.8rem;
  }
}
/deep/.custom_tooltip_box {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  box-shadow: none !important;

  .custom_tooltip_style {
    position: relative;
    .custom_tooltip_inner {
      position: relative;
      z-index: 10;
      left: -10px;
      top: 0;
      // margin:40px;
      padding: 4px 20px 5px 10px;
      border: 1px solid #2a69c6;
      border-radius: 4px;
      background: #103164;
      text-align: left;
    }
    &::after {
      content: "";
      display: block;

      border-top: 30px solid transparent;
      border-left: 20px solid transparent;
      border-bottom: 30px solid transparent;
      border-right: 20px solid #103164;
      position: absolute;
      z-index: 0;
      bottom: -12px;
      left: -26px;
      // bottom: -16px;
      transform: rotate(45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/CompleteRadioAll/ChartFor.vue